var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1E1147",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5727 11.2363L11.2363 19.5728C10.9075 19.9016 10.9075 20.4348 11.2363 20.7637C11.5652 21.0925 12.0984 21.0925 12.4272 20.7637L20.7637 12.4273C21.0925 12.0984 21.0925 11.5652 20.7637 11.2363C20.4348 10.9075 19.9016 10.9075 19.5727 11.2363Z",
    fill: "#2A2B79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7637 19.5727L12.4272 11.2363C12.0984 10.9075 11.5652 10.9075 11.2363 11.2363C10.9075 11.5652 10.9075 12.0984 11.2363 12.4272L19.5727 20.7637C19.9016 21.0925 20.4348 21.0925 20.7637 20.7637C21.0925 20.4348 21.0925 19.9016 20.7637 19.5727Z",
    fill: "#2A2B79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.beda8e2dbf4336d42e3776a73753c7f2.svg";
export { ForwardRef as ReactComponent };